import React, {FC, useEffect, useState} from "react";
import HeaderFilterSection from "components/HeaderFilterSection";
import ProductCard from "components/ProductCard";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Product, PRODUCTS } from "data/data";
import ProductService from "../../app/services/productService";
import Heading from "components/Heading/Heading";

//
export interface SectionGridFeatureItemsProps {
  data?: Product[];
}

const SectionGridFeatureItems: FC<SectionGridFeatureItemsProps> = ({
  data = PRODUCTS,
}) => {
  const [products, setProducts] = useState<Product[]>([]);
  useEffect(() => {


    ProductService.getProducts().then(data => {

      setProducts(data)
    })

  }, [])
  return (
    <div className="nc-SectionGridFeatureItems relative">
      <Heading
        className="mb-12 lg:mb-14 text-neutral-900 dark:text-neutral-50 nc-p-r-container "
        desc=""
        rightDescText=""

        >
        De bonnes découverte vous attendent!
      </Heading>
      <div
        className={`grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 `}
      >
        {products.map((item, index) => (
          <ProductCard data={item} key={index} />
        ))}
      </div>
      <div className="flex mt-16 justify-center items-center">
        <ButtonPrimary href="/shop" >Voir plus</ButtonPrimary>
      </div>
    </div>
  );
};

export default SectionGridFeatureItems;
